import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingIcon from 'mdi-react/LoadingIcon';
import Steps from 'components/steps/Steps';
import { getSteps } from 'redux/actions/stepActions';
import withModal from 'components/modals/withModal';
import { compose } from 'redux';
import PitchPreviewDrawer from 'components/steps/Drawer/PitchPreviewDrawer';
import PitchQualityCheck from 'components/steps/Drawer/PitchQualityCheck';


class StepsTab extends Component {
  static propTypes = {
    getSteps: PropTypes.func.isRequired,
    sequence: PropTypes.shape({
      id: PropTypes.number,
      loading: PropTypes.bool,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    steps: PropTypes.shape({
      results: PropTypes.arrayOf(PropTypes.shape({
        pitches: PropTypes.arrayOf(PropTypes.shape({
          name: PropTypes.string,
          subject: PropTypes.string,
          body: PropTypes.string,
        })),
      })),
    }),
    sequenceContacts: PropTypes.shape({
      count: PropTypes.number.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    steps: {
      results: [],
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      pitchPreviewOpen: false,
      pitchPreviewData: null,
      pitchQualityCheckOpen: false,
    };
  }

  componentDidMount() {
    this.props.getSteps({
      sequence: this.props.match.params.id,
    });
  }

  togglePitchPreview = (value) => {
    this.setState({
      pitchPreviewOpen: value === undefined ? !this.state.pitchPreviewOpen : value,
    });
  }

  togglePitchQualityCheck = (value) => {
    this.setState({
      pitchQualityCheckOpen: value === undefined ? !this.state.pitchQualityCheckOpen : value,
    });
  }

  updatePitchPreviewData = (data) => {
    this.setState({
      pitchPreviewData: data,
    });
  }

  render() {
    const {
      steps,
      sequence,
    } = this.props;
    const isLoading = sequence.loading || steps.loading;
    return (
      <div className="flex">
        <div className="w-100">
          {isLoading && <div className="loader"><LoadingIcon /></div>}
          <div className="instance-form__body">
            <Steps
              steps={steps.results || []}
              pitchQualityCheckOpen={this.state.pitchQualityCheckOpen}
              togglePitchPreview={this.togglePitchPreview}
              togglePitchQualityCheck={this.togglePitchQualityCheck}
              updatePitchPreviewData={this.updatePitchPreviewData}
            />
          </div>
        </div>
        {this.state.pitchPreviewOpen &&
          <PitchPreviewDrawer data={this.state.pitchPreviewData} />
        }
        {this.state.pitchQualityCheckOpen &&
          <PitchQualityCheck />
        }
      </div>
    );
  }
}


export default compose(connect(
  state => ({
    sequence: state.sequence,
    sequenceContacts: state.sequenceContacts,
    steps: state.steps,
  }),
  { getSteps },
))(withModal(StepsTab));
